var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_buscar copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav",
    transform: "translate(-680, -789)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_buscar-copy-3",
    transform: "translate(680, 789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0466989,53.3333333 L77.7133655,80 L80,77.7133655 L53.3333333,51.0466989 C58.2286634,45.6360709 61.1916264,38.4541063 61.1916264,30.5958132 C61.1916264,13.7198068 47.4718196,0 30.5958132,0 C13.7198068,0 0,13.7198068 0,30.5958132 C0,47.4718196 13.7198068,61.1916264 30.5958132,61.1916264 C38.4541063,61.1916264 45.6360709,58.2286634 51.0466989,53.3333333 Z M3.22061192,30.5958132 C3.22061192,15.4911433 15.4911433,3.22061192 30.5958132,3.22061192 C45.7004831,3.22061192 57.9710145,15.4911433 57.9710145,30.5958132 C57.9710145,45.7004831 45.7004831,57.9710145 30.5958132,57.9710145 C15.4911433,57.9710145 3.22061192,45.7004831 3.22061192,30.5958132 Z",
    id: "Shape-Copy-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGray);
export default __webpack_public_path__ + "static/media/search-gray.20f01fbc5d643668eef0f9f5c77d119b.svg";
export { ForwardRef as ReactComponent };